import { Injectable, inject } from '@angular/core';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { IrisModuleFilterBodyComponent } from '../components/module-filter-body/module-filter-body.component';
import { select, Store } from '@ngrx/store';
import * as fromGlobal from '@iris/common/redux/reducers';
import * as fromModuleFilter from '../store/module.filter.reducer';
import { tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class IrisModuleFilterOverlayService {
  private readonly overlay = inject(Overlay);
  private readonly store = inject<Store<fromGlobal.State>>(Store);

  private overlayRef: OverlayRef;
  private readonly filterPanelPortal: ComponentPortal<IrisModuleFilterBodyComponent>;

  constructor() {
    this.filterPanelPortal = new ComponentPortal(IrisModuleFilterBodyComponent);

    this.store.pipe(select(fromModuleFilter.getModuleVisibility))
      .pipe(
        tap(visible => visible ? this.openFilter() : this.closeFilter()),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  private getOverlayConfig(): OverlayConfig {
    const positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();

    return new OverlayConfig({
      positionStrategy,
      panelClass: 'filter-custom-panel',
    });
  }

  openFilter(): void {
    this.overlayRef = this.overlay.create(this.getOverlayConfig());
    const component = this.overlayRef.attach(this.filterPanelPortal);
    this.overlayRef.hostElement.classList.add('filter-overlay-container');
    component.instance.setOverlayElem(this.overlayRef.hostElement.parentElement);
  }

  closeFilter(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }
}
